var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 556.69 437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.96 215.97 259.4 215.97 259.4 238.34 218.85 238.34 218.85 249.21 253.66 249.21 253.66 269.98 218.85 269.98 218.85 303.21 191.96 303.21 191.96 215.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "268.93 215.97 341.15 215.97 341.15 238.34 295.82 238.34 295.82 249.21 336.99 249.21 336.99 269.98 295.82 269.98 295.82 280.85 342.49 280.85 342.49 303.21 268.93 303.21 268.93 215.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.94,216H399c29.08,0,39.35,21.5,39.35,43.49,0,26.77-14.16,43.75-44.59,43.75H354.94V216Zm26.88,64.88h10.51c16.75,0,19.18-13.57,19.18-21.76,0-5.5-1.71-20.77-21.14-20.77h-8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.18,216h26.27l31.78,87.24H504.37l-3.66-12.46H473l-3.9,12.46h-27Zm21.13,56.08-7.81-26.89h-.24l-8.43,26.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.96 314.05 203 314.05 203 316.01 194.77 316.01 194.77 319.39 202 319.39 202 321.24 194.77 321.24 194.77 326.98 191.96 326.98 191.96 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "205.25 314.05 216.76 314.05 216.76 316.01 208.05 316.01 208.05 319.39 216.1 319.39 216.1 321.24 208.05 321.24 208.05 325.03 216.91 325.03 216.91 326.98 205.25 326.98 205.25 314.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.37,314.05H226c4.92,0,7.06,2.9,7.06,6.47S230.92,327,226,327h-6.63Zm2.8,11.1h2.76c4.38,0,5.32-2,5.32-4.63s-.94-4.62-5.32-4.62h-2.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "235.55 314.05 247.04 314.05 247.04 316.01 238.34 316.01 238.34 319.39 246.4 319.39 246.4 321.24 238.34 321.24 238.34 325.03 247.21 325.03 247.21 326.98 235.55 326.98 235.55 314.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.65,314.05h7.64c3.49,0,5.28,1.31,5.28,3.51a3.32,3.32,0,0,1-2.64,3.26v0a2.52,2.52,0,0,1,2.37,2.75c0,1.5.27,2.87.88,3.4h-3a3,3,0,0,1-.43-1.91c0-2.37-.6-3.43-3.18-3.43h-4.11V327h-2.81V314.05Zm2.81,5.89h4.59c1.77,0,2.73-.71,2.73-2.07,0-1.66-1.33-2-2.78-2h-4.54v4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.71,314.05h3L278.85,327h-3l-1.51-3.43H268l-1.5,3.43h-2.9Zm-1,7.79h4.88l-2.39-5.57h-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.16,318.17c-.47-1.49-1.65-2.58-4-2.58a4.93,4.93,0,0,0,0,9.85,3.75,3.75,0,0,0,4.07-3.38H294c-.22,3.1-2.93,5.23-6.8,5.23-4.78,0-7.66-3.08-7.66-6.77s2.86-6.78,7.66-6.78c3.61,0,6.44,1.62,6.79,4.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 296.55,
    y: 314.05,
    width: 2.8,
    height: 12.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.24,320.52c0,3.7-2.86,6.77-7.65,6.77s-7.66-3.08-7.66-6.77,2.86-6.78,7.66-6.78,7.65,3.09,7.65,6.78m-12.51,0a4.87,4.87,0,1,0,4.86-4.92,4.58,4.58,0,0,0-4.86,4.92m5.19-10.08h3l-3.18,2.6h-1.85Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "319.7 314.05 322.66 314.05 329.95 323.58 329.99 323.58 329.99 314.05 332.66 314.05 332.66 326.98 329.71 326.98 322.43 317.47 322.36 317.47 322.36 326.98 319.7 326.98 319.7 314.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "342.22 314.05 353.73 314.05 353.73 316.01 345.01 316.01 345.01 319.39 353.07 319.39 353.07 321.24 345.01 321.24 345.01 325.03 353.88 325.03 353.88 326.98 342.22 326.98 342.22 314.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M367.12,318.17c-.48-1.49-1.65-2.58-4-2.58a4.93,4.93,0,0,0,0,9.85,3.76,3.76,0,0,0,4.07-3.38h2.73c-.23,3.1-2.94,5.23-6.8,5.23-4.79,0-7.67-3.08-7.67-6.77s2.87-6.78,7.67-6.78c3.59,0,6.44,1.62,6.78,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.32,314.05h2.81v7.53c0,1.75.13,3.76,3.76,3.76s3.75-2,3.75-3.76v-7.53h2.81v8.28c0,3.31-2.63,5-6.56,5s-6.57-1.65-6.57-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M393,314.05h3L402.1,327h-3l-1.5-3.43h-6.38L389.71,327h-2.89Zm-1,7.79h4.87l-2.4-5.57h-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "400.04 314.05 412.99 314.05 412.99 316.01 407.9 316.01 407.9 326.98 405.1 326.98 405.1 316.01 400.04 316.01 400.04 314.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.31,320.52c0,3.7-2.86,6.79-7.65,6.79s-7.66-3.09-7.66-6.79,2.86-6.78,7.66-6.78,7.65,3.09,7.65,6.78m-12.51,0c0,2.48,1.43,4.94,4.86,4.94a4.93,4.93,0,0,0,0-9.86c-3.43,0-4.86,2.43-4.86,4.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M431.88,314.05h7.63c3.49,0,5.28,1.31,5.28,3.51a3.31,3.31,0,0,1-2.64,3.26v0a2.52,2.52,0,0,1,2.37,2.75c0,1.5.27,2.87.88,3.4h-3a3,3,0,0,1-.44-1.91c0-2.37-.59-3.43-3.17-3.43h-4.12V327h-2.8V314.05Zm2.8,5.89h4.59c1.76,0,2.73-.71,2.73-2.07,0-1.66-1.32-2-2.77-2h-4.55v4.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 447.65,
    y: 314.05,
    width: 2.8,
    height: 12.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M458.17,314.05h3L467.31,327h-3l-1.51-3.43h-6.38l-1.5,3.43H452Zm-1,7.79H462l-2.38-5.57h-.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "468.72 314.05 471.68 314.05 478.97 323.58 479.01 323.58 479.01 314.05 481.68 314.05 481.68 326.98 478.73 326.98 471.45 317.47 471.38 317.47 471.38 326.98 468.72 326.98 468.72 314.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M489.29,314.05h3L498.43,327h-3l-1.51-3.43h-6.38L486,327h-2.89Zm-1,7.79h4.88l-2.39-5.57h-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M506.18,314.05h6.63c4.93,0,7.06,2.9,7.06,6.47s-2.12,6.48-7.06,6.48h-6.63Zm2.8,11.1h2.76c4.38,0,5.32-2,5.32-4.63s-.94-4.62-5.32-4.62H509Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "522.36 314.05 533.87 314.05 533.87 316.01 525.16 316.01 525.16 319.39 533.21 319.39 533.21 321.24 525.16 321.24 525.16 325.03 534.02 325.03 534.02 326.98 522.36 326.98 522.36 314.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,335.24h5.71l8.09,16.46H208l-1.33-2.95H199.1l-1.35,2.95H192Zm.36,10.33h4.91l-2.39-5.75h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.43,351.7H231.8l-.32-1.79c-1.49,1.6-4,2.15-6,2.15-6.53,0-10.76-3.8-10.76-8.57s4.23-8.58,10.76-8.58c4.48,0,9.26,1.82,9.77,5.95H229.6c-.18-1.4-2-2.25-4.27-2.25-3.62,0-5,2.45-5,4.89s1.4,4.89,5,4.89c2.79,0,4.66-1,5-2.49h-3.94v-3.17h9.08v9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "239.04 335.24 256.26 335.24 256.26 338.69 244.67 338.69 244.67 341.56 255.26 341.56 255.26 344.87 244.67 344.87 244.67 348.02 256.56 348.02 256.56 351.7 239.04 351.7 239.04 335.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "259.72 335.24 265.5 335.24 273 345.38 273.06 345.38 273.06 335.24 278.36 335.24 278.36 351.7 272.57 351.7 265.07 341.44 265.01 341.44 265.01 351.7 259.72 351.7 259.72 335.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "299.34 338.94 292.89 338.94 292.89 351.7 287.27 351.7 287.27 338.94 280.83 338.94 280.83 335.24 299.34 335.24 299.34 338.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "301.84 335.24 319.05 335.24 319.05 338.69 307.46 338.69 307.46 341.56 318.05 341.56 318.05 344.87 307.46 344.87 307.46 348.02 319.36 348.02 319.36 351.7 301.84 351.7 301.84 335.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327,346.17c.11,1.94,1.7,2.57,4.08,2.57,1.7,0,3.45-.47,3.45-1.69,0-1.45-3.09-1.73-6.21-2.4s-6.32-1.73-6.32-4.74c0-3.6,4.74-5,8.8-5,4.29,0,8.62,1.6,8.65,5.31h-5.63c.09-1.5-1.75-2-3.47-2-1.21,0-2.73.33-2.73,1.4,0,1.27,3.12,1.51,6.26,2.16s6.27,1.78,6.27,4.74c0,4.18-4.66,5.51-9.41,5.51-5,0-9.35-1.66-9.38-5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M352.31,335.24h9.29c6.62,0,10.59,3.07,10.59,8.16,0,5.39-4,8.3-10.59,8.3h-9.29ZM357.94,348h2.66c4.27-.07,6-1.34,6-4.64,0-3-2.12-4.44-6-4.44h-2.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "375.29 335.24 392.5 335.24 392.5 338.69 380.91 338.69 380.91 341.56 391.5 341.56 391.5 344.87 380.91 344.87 380.91 348.02 392.81 348.02 392.81 351.7 375.29 351.7 375.29 335.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M411.44,335.24h5.71l8.08,16.46h-5.86L418,348.75h-7.53l-1.36,2.95h-5.77Zm.35,10.33h4.91l-2.39-5.75h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.88,335.24h9.29c6.62,0,10.59,3.07,10.59,8.16,0,5.39-4,8.3-10.59,8.3h-9.29ZM432.5,348h2.67c4.27-.07,6-1.34,6-4.64,0-3-2.12-4.44-6-4.44H432.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M468.53,344.9c0,4.77-2.88,7.15-9.41,7.15s-9.41-2.38-9.41-7.15v-9.66h5.62v9.92c0,2.11,1,3.2,3.79,3.2s3.79-1.09,3.79-3.2v-9.92h5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M478.16,335.24h5.71L492,351.7h-5.87l-1.33-2.95h-7.53l-1.35,2.95h-5.78Zm.37,10.33h4.91l-2.39-5.75H481Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "493.55 335.24 499.33 335.24 506.83 345.38 506.89 345.38 506.89 335.24 512.19 335.24 512.19 351.7 506.4 351.7 498.9 341.44 498.84 341.44 498.84 351.7 493.55 351.7 493.55 335.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M521.93,335.24h5.71l8.08,16.46h-5.88l-1.32-2.95H521l-1.36,2.95h-5.77Zm.35,10.33h4.91l-2.39-5.75h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.38,287.87A12.36,12.36,0,0,0,17.06,300a12.47,12.47,0,0,0,12.61-12.26A12.33,12.33,0,0,0,17,275.63,12.48,12.48,0,0,0,4.38,287.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,328.87a12.92,12.92,0,0,0,13.29,12.66,12.75,12.75,0,1,0-.06-25.48A13.07,13.07,0,0,0,0,328.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.43,371.94A12.94,12.94,0,0,0,13.72,384.6a13.07,13.07,0,0,0,13.22-12.84,12.93,12.93,0,0,0-13.28-12.65A13.08,13.08,0,0,0,.43,371.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.63,414.94A12.94,12.94,0,0,0,20.92,427.6a13.09,13.09,0,0,0,13.23-12.84,12.93,12.93,0,0,0-13.29-12.64A13.08,13.08,0,0,0,7.63,414.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.9,242.53A12.33,12.33,0,0,0,25.57,254.6a12.48,12.48,0,0,0,12.62-12.24A12.34,12.34,0,0,0,25.51,230.3,12.44,12.44,0,0,0,12.9,242.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.82,202.68A12.35,12.35,0,0,0,40.5,214.76a12.46,12.46,0,0,0,12.61-12.24,12.33,12.33,0,0,0-12.67-12.06,12.44,12.44,0,0,0-12.62,12.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.83,162.14a12.66,12.66,0,1,0,12.62-12.23,12.35,12.35,0,0,0-12.62,12.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.41,93.3a10.54,10.54,0,0,0,10.82,10.32A10.66,10.66,0,0,0,126,93.15a10.54,10.54,0,0,0-10.82-10.31A10.66,10.66,0,0,0,104.41,93.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.54,63.49a9.63,9.63,0,1,0,9.6-9.32,9.41,9.41,0,0,0-9.6,9.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.17,35.91a9,9,0,1,0,9-8.68,8.77,8.77,0,0,0-9,8.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.55,16.72a6.59,6.59,0,0,0,6.77,6.45,6.67,6.67,0,0,0,6.74-6.54,6.6,6.6,0,0,0-6.77-6.45,6.66,6.66,0,0,0-6.74,6.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.49,4.47a4.51,4.51,0,0,0,4.63,4.42,4.56,4.56,0,0,0,4.6-4.48A4.5,4.5,0,0,0,263.1,0a4.56,4.56,0,0,0-4.61,4.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.36,125.19a10.54,10.54,0,0,0,10.82,10.32A10.67,10.67,0,0,0,97,125a10.54,10.54,0,0,0-10.83-10.3,10.66,10.66,0,0,0-10.78,10.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.62,82.25a11.52,11.52,0,0,0,1.25,16.3,11.65,11.65,0,0,0,16.4-.63,11.81,11.81,0,0,0-17.65-15.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.74,107.94a12.38,12.38,0,1,0,17.17-.64,12.08,12.08,0,0,0-17.17.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.58,139.49a12.39,12.39,0,1,0,17.18-.64,12.09,12.09,0,0,0-17.18.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.1,176.38a12.38,12.38,0,1,0,17.18-.64,12.1,12.1,0,0,0-17.18.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.25,211.27a12.1,12.1,0,0,0,1.31,17.09,12.23,12.23,0,0,0,17.2-.66,12.39,12.39,0,0,0-18.51-16.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.89,248.91a12.38,12.38,0,1,0,17.18-.64,12.1,12.1,0,0,0-17.18.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.2,287.91a12.38,12.38,0,1,0,17.17-.64,12.1,12.1,0,0,0-17.17.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.24,329.43a12.38,12.38,0,1,0,17.18-.65,12.09,12.09,0,0,0-17.18.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.81,368.75a12.08,12.08,0,0,0,1.31,17.08A11.91,11.91,0,1,0,61,368.1a12.2,12.2,0,0,0-17.18.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,409a12.07,12.07,0,0,0,1.31,17.08,11.9,11.9,0,1,0,15.86-17.73A12.18,12.18,0,0,0,51,409"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.67,60.43a11.52,11.52,0,0,0,1.26,16.3,11.65,11.65,0,0,0,16.4-.62,11.53,11.53,0,0,0-1.27-16.29,11.65,11.65,0,0,0-16.39.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.13,41.24a11.53,11.53,0,0,0,1.25,16.3,11.66,11.66,0,0,0,16.41-.63,11.53,11.53,0,0,0-1.27-16.28,11.65,11.65,0,0,0-16.39.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.35,29.21a11.52,11.52,0,0,0,1.25,16.3,11.65,11.65,0,0,0,16.4-.63,11.81,11.81,0,0,0-17.65-15.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.81,19.91a9.84,9.84,0,0,0,1.07,13.92,10,10,0,0,0,14-.53,10.09,10.09,0,0,0-15.08-13.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M397.33,23.93a8.39,8.39,0,0,0,12.54,11.13,8.39,8.39,0,0,0-12.54-11.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M438.63,32.92a7,7,0,0,0,.76,9.83,7,7,0,0,0,9.9-.39,7,7,0,0,0-.76-9.82,7,7,0,0,0-9.9.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.06,46.7a6.15,6.15,0,0,0,.67,8.71,6.07,6.07,0,1,0-.67-8.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M514,65a6.16,6.16,0,0,0,.67,8.71,6.23,6.23,0,0,0,8.77-.34,6.16,6.16,0,0,0-.67-8.7A6.24,6.24,0,0,0,514,65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M547.45,88.42a5.34,5.34,0,1,0,7.4-.28,5.27,5.27,0,0,0-7.4.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315,21.8a9.86,9.86,0,0,0,1.07,13.93,10,10,0,0,0,14-.54A10.1,10.1,0,0,0,315,21.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171,131.39a10.25,10.25,0,1,0,14.12-1.77A10,10,0,0,0,171,131.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148,155.73a10.46,10.46,0,0,0,2.43,14.67A10.34,10.34,0,1,0,148,155.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.13,183.21a10.75,10.75,0,1,0,14.81-1.86,10.5,10.5,0,0,0-14.81,1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.87,215.63a10.48,10.48,0,0,0,2.43,14.68,10.34,10.34,0,1,0-2.43-14.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.07,247.16a10.75,10.75,0,1,0,14.81-1.86,10.5,10.5,0,0,0-14.81,1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.47,281.16a10.75,10.75,0,1,0,14.8-1.86,10.5,10.5,0,0,0-14.8,1.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.71,316.13a10.75,10.75,0,1,0,14.81-1.87,10.59,10.59,0,0,0-14.81,1.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.77,351.24a10.75,10.75,0,1,0,14.81-1.85,10.5,10.5,0,0,0-14.81,1.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.6,385.39A10.47,10.47,0,0,0,90,400.06a10.59,10.59,0,0,0,14.82-1.88,10.48,10.48,0,0,0-2.44-14.67,10.6,10.6,0,0,0-14.81,1.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.16,420.14a10.48,10.48,0,0,0,2.43,14.68,10.6,10.6,0,0,0,14.82-1.88A10.49,10.49,0,0,0,112,418.26a10.61,10.61,0,0,0-14.81,1.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.69,108.51a10.25,10.25,0,1,0,14.12-1.78,10,10,0,0,0-14.12,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.76,90A10.26,10.26,0,1,0,243.9,88.2,10.12,10.12,0,0,0,229.76,90"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.33,76.06a10,10,0,0,0,2.32,14,10.11,10.11,0,0,0,14.14-1.79,10,10,0,0,0-2.33-14,10.11,10.11,0,0,0-14.13,1.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.38,61.84a8.53,8.53,0,0,0,2,12,8.43,8.43,0,1,0-2-12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.75,62a7.93,7.93,0,1,0,10.91-1.37A7.73,7.73,0,0,0,366.75,62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M403.89,67.62a7.11,7.11,0,0,0,1.64,9.95,7.19,7.19,0,0,0,10.05-1.27,7.29,7.29,0,0,0-11.69-8.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M440.3,76.87a5.35,5.35,0,0,0,1.24,7.48,5.41,5.41,0,0,0,7.56-.95,5.35,5.35,0,0,0-1.24-7.47,5.4,5.4,0,0,0-7.56.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.57,89.5A4.67,4.67,0,0,0,472.66,96a4.6,4.6,0,1,0-1.09-6.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M504.55,108.54a4,4,0,0,0,.94,5.63,4,4,0,1,0-.94-5.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.49,67.55a8.53,8.53,0,0,0,2,12A8.64,8.64,0,0,0,311.55,78a8.53,8.53,0,0,0-2-12,8.62,8.62,0,0,0-12.06,1.52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.ba2cace4a8a19b1e5e99e554071b4a2b.svg";
export { ForwardRef as ReactComponent };